<template lang="pug">
  transition(name="modal-fade")
    .modal-backdrop
      .modal
        header(class="modal-header")
          slot(name="header")
            h1 Submit Score
            button(type="button", class="btn-close" @click="close") X
        section(class="modal-body")
          slot(name="body" id="body")
            .grid
              label {{game.players[0].name}}
              input(type="number" v-model="first")
              p -
              p -
              label {{game.players[1].name}}
              input(type="number" v-model="second")
            .wrapper
              button(type="button" @click="submitScore" class="button") Submit Score
</template>
<script>
import Event from '../event.js';
export default {
  name: 'modal',
  props: {
    'turn': {
      type: String,
    },
    'game': {
      type: Object,
    }
  },
  data() {
    return {
      first: 0,
      second: 0,
    }
  },
/*   watch: {
    game: function() {
      console.log('gamewatcher');
      console.log(this.game);
    }
  }, */
  methods: {
    close() {
      Event.$emit('close');
    },
    submitScore() {
      console.log(this.index);
      Event.$emit('submitScore', this.first, this.second, this.turn);
      this.index = this.index + 1;
      console.log(this.index);
      Event.$emit('closeAndSub');
    },
  },
};
</script>
<style lang="scss" scoped>

  label{
    font-size: 35px;
  }

  p {
    font-size: 35px;
    text-align: center;
  }

  input {
    font-size: 30px;
    width: 100%;
    padding: 20px;
    margin: 8px 0;
    box-sizing: border-box;
    border: 3px solid #ccc;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    outline: none;
    text-align: center;
  }

  input:focus {
    border: 3px solid #555;
  }

.button {
    background-color: #9F1002;
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    border: 2px solid #9F1002;
  }
  .button:hover {
    background-color: white;
    color: black;
  }

  .modal-fade-enter, .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    width: 500px;
    height: 310px;
    box-shadow: 2px 2px 20px 1px;
    //overflow-x: auto;
    display: flex;
    flex-direction: column;
    border: 2px solid darkgray;
  }

  .modal-header,
  .modal-footer {
    padding: 10px;
    display: flex;
    background: #9F1002;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
    font-size: 20px;
    text-align: center;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px;
    align-content: center;
    .grid {
      display: grid;
      width: 100%;
      height: 50%;
      grid-template-columns: 45% 10% 45%;
      grid-template-rows: repeat(2, 50%);
      grid-column-gap: 5px;
      grid-row-gap: 5px;
      grid-auto-flow: column;
    }
  }

  .wrapper{
    text-align: center;
    button{
      padding: 20px;
      align-self: center;
      margin-top: 5%;
    }
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>

